var React = require('react');

function SDCRotatePagesCCW18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.41881,2.17152a7.717,7.717,0,0,0-7.64,2.702l-.06518-1.9901A.5.5,0,0,0,2.19763,2.4l-.50054.0163a.5.5,0,0,0-.48347.516v.00008l.14865,4.543a.5.5,0,0,0,.51608.48339l.037-.00259,4.52007-.48492a.5.5,0,0,0,.44382-.55048l0-.00006-.05338-.497A.5.5,0,0,0,6.27542,5.98L3.606,6.26611a6.23969,6.23969,0,1,1-.09574,6.84242.50618.50618,0,0,0-.6945-.17355l-.02373.01515-.40606.28433a.50251.50251,0,0,0-.14429.6751,7.75032,7.75032,0,1,0,8.17717-11.738Z","fill":"var(--iconFill, #464646)"}));
}

SDCRotatePagesCCW18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCRotatePagesCCW18N;

SDCRotatePagesCCW18N.default = SDCRotatePagesCCW18N;
